import { render, staticRenderFns } from "./customeTable.vue?vue&type=template&id=1be2b75b&"
import script from "./customeTable.vue?vue&type=script&lang=js&"
export * from "./customeTable.vue?vue&type=script&lang=js&"
import style0 from "./customeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports